import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import messages from './messages';
import style from './style.module.less';
import FormattedCurrency from '../../../../../components/formatted-currency';
import ModalPortal from '../../../../../components/modal-portal';
import { emptyArray } from 'ui-components/default-props/empty';
import { DiscountPropType } from '../../../../../prop-types/discount';

const DiscountModal = ({ onClose, discounts = emptyArray }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal size='small'>
        <ModalHeader>
          <FormattedMessage {...messages.discountModalHeader} />
        </ModalHeader>
        <ModalBody>
          <table className={style['discount-table']}>
            <thead>
              <tr>
                <th>
                  <FormattedMessage {...messages.discountTableDescription} />
                </th>
                <th>
                  <FormattedMessage {...messages.discountTableDiscountAmount} />
                </th>
              </tr>
            </thead>
            <tbody>
              {discounts.map(({ amount, description }, index) => {
                return (
                  <tr key={index}>
                    <td>{description}</td>
                    <td>
                      <FormattedCurrency currencyCode={amount.code} value={amount.value} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

DiscountModal.propTypes = {
  discounts: PropTypes.arrayOf(DiscountPropType),
  onClose: PropTypes.func.isRequired,
};

export { DiscountModal };
